import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

function AboutUs() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col lg={10}>
          <h2 className="text-center mb-4">About Little Love Nature</h2>
          <p className="text-center text-muted mb-5">
            Where comfort meets nature — thoughtfully crafted clothing for little ones.
          </p>

          <Card className="p-4 shadow-sm mb-4">
            <Card.Body>
              <h4>Our Story</h4>
              <p>
                Little Love Nature was born from a simple dream — to create clothing 
                for children that’s as pure, gentle, and beautiful as nature itself. 
                We understand that every parent wants the best for their little ones, 
                and that’s why we design our collections with love, care, and responsibility.
              </p>
            </Card.Body>
          </Card>

          <Card className="p-4 shadow-sm mb-4">
            <Card.Body>
              <h4>Our Mission</h4>
              <ul>
                <li>
                  To provide <strong>safe, soft, and comfortable clothing</strong> 
                  that’s perfect for children’s delicate skin.
                </li>
                <li>
                  To use <strong>sustainable fabrics</strong> and eco-friendly 
                  practices that protect the future of our planet.
                </li>
                <li>
                  To design styles that are both <strong>playful and practical</strong>, 
                  letting kids be kids while looking adorable.
                </li>
              </ul>
            </Card.Body>
          </Card>

          <Card className="p-4 shadow-sm mb-4">
            <Card.Body>
              <h4>What Makes Us Different</h4>
              <ul>
                <li>
                  <strong>Natural Fabrics:</strong> Breathable, skin-friendly 
                  materials that keep little ones comfy all day.
                </li>
                <li>
                  <strong>Eco-Conscious:</strong> Sustainable production and 
                  packaging choices to care for Mother Earth.
                </li>
                <li>
                  <strong>Thoughtful Design:</strong> Clothes made with 
                  attention to detail, ensuring durability and comfort.
                </li>
              </ul>
            </Card.Body>
          </Card>

          <Card className="p-4 shadow-sm">
            <Card.Body>
              <h4>Our Vision</h4>
              <p>
                We believe in a world where children grow up surrounded by love, 
                joy, and respect for nature. At Little Love Nature, we’re not 
                just making clothes — we’re weaving values of sustainability, 
                kindness, and care into every stitch.
              </p>
              <p>
                <strong>
                  Thank you for choosing Little Love Nature — where every outfit 
                  tells a story of love, comfort, and nature.
                </strong>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AboutUs;
